import { render, staticRenderFns } from "./DescriptionSetter.vue?vue&type=template&id=9b14ca00&scoped=true&"
import script from "./DescriptionSetter.vue?vue&type=script&lang=js&"
export * from "./DescriptionSetter.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionSetter.vue?vue&type=style&index=0&id=9b14ca00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b14ca00",
  null
  
)

component.options.__file = "DescriptionSetter.vue"
export default component.exports